import script from "./LobbyView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LobbyView.vue?vue&type=script&setup=true&lang=ts"

import "./LobbyView.vue?vue&type=style&index=0&id=55028826&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55028826"]])

export default __exports__